.tag-container {
    border-bottom: 1px solid transparent;
}

.tag-container:hover {
    border-bottom: 1px solid var(--off-white-dk);
}
